import { StyleSheet } from 'react-native-unistyles';

export const styles = StyleSheet.create((colors) => ({
  // The secondary Button variant supplies the border, radius, height and
  // padding. On an inverse surface its border token resolves to the same end of
  // the scale as the surface, so only the border color is restated here.
  inverseButton: {
    borderColor: colors.borderInverse,
  },
}));
